<template>
  <component
    :is="wrapperTag"
    :to="to"
    :disabled="isButtonDisabled"
    class="button__wrapper text-body-sm"
    :class="dynamicClass"
    v-on="$listeners"
  >
    <button-spinner v-if="loading" />
    <slot v-else></slot>
  </component>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import ALink from 'shared/ALink/index.vue'
import { HTML_TAG } from '@fmpedia/enums'
import ButtonSpinner from 'shared/AButton/ButtonSpinner/index.vue'
import { BUTTON_STYLE } from 'shared/AButton/enums'

export default {
  name: 'AButton',
  components: { ButtonSpinner },
  props: {
    to: propValidator([PROP_TYPES.STRING, PROP_TYPES.OBJECT], false),
    disabled: propValidator([PROP_TYPES.BOOLEAN], false, false),
    loading: propValidator([PROP_TYPES.BOOLEAN], false, false),
    buttonStyle: propValidator(
      [PROP_TYPES.STRING],
      false,
      BUTTON_STYLE.GREEN,
      value => Object.values(BUTTON_STYLE).includes(value)
    )
  },
  computed: {
    wrapperTag() {
      return this.to ? ALink : HTML_TAG.BUTTON
    },
    isButtonDisabled() {
      return this.disabled || this.loading
    },
    dynamicClass() {
      return {
        disabled: this.disabled,
        loading: this.loading,
        [this.buttonStyle]: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$colorByStyle: (
  'green': $c--black,
  'green-dark': $c--green-main,
  'blue': $c--white,
  'black': $c--white
);

$bgColorByStyle: (
  'green': $c--green-main,
  'blue': $c--red-main,
  'black': $c--black,
  'green-dark': $c--green-dark
);

$hoverBgColorByStyle: (
  'green': $c--green-main-hover,
  'green-dark': $c--green-main-hover,
  'blue': $c--red-main-hover
);

$hoverColorByStyle: (
  'green-dark': $c--black
);

@mixin styleButton($type) {
  &.#{$type} {
    background-color: map-get($bgColorByStyle, $type);
    color: map-get($colorByStyle, $type);

    &:hover:not(.disabled):not(.loading) {
      background-color: map-get($hoverBgColorByStyle, $type);
      color: map-get($hoverColorByStyle, $type);
    }
  }
}

.button__wrapper {
  transition: background-color 0.3s ease;
  color: $c--black;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  text-decoration: none;

  @include styleButton('green');
  @include styleButton('green-dark');
  @include styleButton('blue');
  @include styleButton('black');

  &.disabled {
    cursor: not-allowed;
  }

  &.loading {
    cursor: not-allowed;
  }
}
</style>
